/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseReadFileCallReadingEvent = {
  type: "response.read_file_call.reading";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseReadFileCallReadingEvent$inboundSchema: z.ZodType<
  ResponseReadFileCallReadingEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.read_file_call.reading"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseReadFileCallReadingEvent$Outbound = {
  type: "response.read_file_call.reading";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseReadFileCallReadingEvent$outboundSchema: z.ZodType<
  ResponseReadFileCallReadingEvent$Outbound,
  z.ZodTypeDef,
  ResponseReadFileCallReadingEvent
> = z.object({
  type: z.literal("response.read_file_call.reading"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseReadFileCallReadingEventToJSON(
  responseReadFileCallReadingEvent: ResponseReadFileCallReadingEvent,
): string {
  return JSON.stringify(
    ResponseReadFileCallReadingEvent$outboundSchema.parse(
      responseReadFileCallReadingEvent,
    ),
  );
}
export function responseReadFileCallReadingEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseReadFileCallReadingEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseReadFileCallReadingEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseReadFileCallReadingEvent' from JSON`,
  );
}
